import React, { useState } from "react";
import { useParams } from "react-router-dom";
import AppCustomerUserRolePrivileges from "@/components/privileges/appCustomerUserRolePrivileges/AppCustomerUserRolePrivileges";

const AppCustomerUserRolePrivilegesPage = () => {
  const { appId, customerId, userId, roleId } = useParams();
  const [roleName, setRoleName] = useState<string>("");

  const handleRoleLoaded = (name: string) => {
    setRoleName(name);
  };

  return (
    <>
      <AppCustomerUserRolePrivileges
        ApplicationId={Number(appId)}
        CustomerId={Number(customerId)}
        UserId={Number(userId)}
        RoleId={Number(roleId)}
        onRoleLoaded={handleRoleLoaded}
        breadcrumbTitle="Application | Customer | User | Role | Privileges"
        breadcrumbSubtitle={
          roleName ? (
            <>
              Manage privileges for role <strong>{roleName}</strong>
            </>
          ) : (
            "Manage privileges for this role"
          )
        }
        backPath={`/applications/${appId}/customers/${customerId}/users/${userId}/roles`}
      />
    </>
  );
};

export default AppCustomerUserRolePrivilegesPage;
